import React from "react";
import ErrorMessage from "../common-components/ErrorMessage";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { ChildFormProps } from "../../../types/Form-types";
import InputCell from "./InputCell";

interface HrFinalDetailsProps extends ChildFormProps {
  // handleChange: (e: React.ChangeEvent<any>) => void;
  handleDateChange: (name: string, value: string) => void;
  handleFieldChange: (name: string, value: string) => void;
}

const HrFinalRecommendation = ({
  formData,
  errors,
  handleDateChange,
  handleFieldChange,
}: HrFinalDetailsProps) => {
  return (
    <>
      {" "}
      {/* Final HR Recommendations */}
      <div className="table-responsive mb-4">
        <table className="form-table">
          <tbody>
            <tr>
              <td className="td-label fw-semibold">
                Final HR Recommendations:&nbsp;
                <span className="text-danger">*</span>
              </td>
              <td colSpan={3}>
                <textarea
                  rows={2}
                  className="form-control"
                  value={formData.final_hr_recommendation}
                  onChange={(e) =>
                    handleFieldChange("final_hr_recommendation", e.target.value)
                  }
                />
                <ErrorMessage
                  message={(errors as any).final_hr_recommendation}
                />
              </td>
            </tr>
            <tr>
              <td className="td-label fw-semibold">
                Grade & Designation to be allocated: &nbsp;
                <span className="text-danger">*</span>
              </td>
              <td colSpan={3}>
                <textarea
                  rows={2}
                  className="form-control"
                  value={formData.grade_designation_allocated}
                  onChange={(e) =>
                    handleFieldChange(
                      "grade_designation_allocated",
                      e.target.value,
                    )
                  }
                />
                <ErrorMessage
                  message={(errors as any).grade_designation_allocated}
                />
              </td>
            </tr>
            <tr>
              <td className="td-label">
                CTC to be offered&nbsp;<span className="text-danger">*</span>
              </td>
              <InputCell
                name="ctc_to_be_offered"
                type="number"
                value={String(formData?.ctc_to_be_offered ?? "")}
                handleChange={(v) => handleFieldChange("ctc_to_be_offered", v)}
                errorMessage={(errors as any).ctc_to_be_offered}
              />
              <td className="td-label">
                Onboarding Date&nbsp;<span className="text-danger">*</span>
              </td>
              <td style={{ minWidth: "120px" }}>
                <DatePicker
                  style={{ maxWidth: "100px", marginTop: "-0.5rem" }}
                  className="p-0 ps-1 form-control datetimepicker d-inline"
                  format={{ format: "DD-MM-YYYY", type: "mask" }}
                  placeholder="DD-MM-YYYY"
                  value={
                    formData.onboarding_date
                      ? dayjs(formData.onboarding_date, "YYYY-MM-DD")
                      : ""
                  }
                  // --- onboarding can't be in past ---
                  disabledDate={(current) => {
                    const start = dayjs(dayjs(), "DD-MM-YYYY");
                    return current && current.isBefore(start, "date");
                  }}
                  onChange={(date: any, dateString: string | string[]) => {
                    if (!date) return;
                    handleDateChange(
                      "onboarding_date",
                      typeof dateString === "string"
                        ? dateString
                        : dateString[0],
                    );
                  }}
                />
                <ErrorMessage message={(errors as any).onboarding_date} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default HrFinalRecommendation;
